import React, { Component } from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { Panel } from "react-bootstrap";
import { invokeApig } from '../../libs/awsLib';

export default class TripsChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      data: []
    };
  }

  componentDidMount = async () => {
  	this.setState({ isLoading: true, data: [] });

	this.trips().then((response) => {
		this.setState({ data: response, isLoading: false });
	}, (error) => {
		alert(error);
		this.setState({ isLoading: false });
	});
  }
  trips() {
      return invokeApig({
          path: "/summary/trips",
          method: "POST",
          body: {}
      });
  }

  renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
	const RADIAN = Math.PI / 180;                    
	const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
	const x  = cx + radius * Math.cos(-midAngle * RADIAN);
	const y = cy  + radius * Math.sin(-midAngle * RADIAN);
	return (
	    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
	    	{`${(percent * 100).toFixed(0)}%`}
	    </text>
	);
  }

  renderChart() {
	  let style = {
        width: 170,
        height: 295
      };
	  const data = this.state.data;
	  const COLORS = ['#00C49F', '#FF8042', '#FF0000', '#0088FE', '#FFBB28'];
	  return (
	    <div className="item" style={style}>
	    <ResponsiveContainer>
	      <PieChart width={170} height={250} onMouseEnter={this.onPieEnter}>
	          <Pie data={data} dataKey='value' cx={80} cy={80} labelLine={false} label={this.renderCustomizedLabel} outerRadius={80} fill="#8884d8">
	            {
	            	data.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]}/>)
	            }
	          </Pie>
	          <Legend/>
	      </PieChart>
        </ResponsiveContainer>
	    </div>
	  );
  }
  render() {
    return (
	  <center>
	    <Panel className="Chart">
          <Panel.Heading>Viajes</Panel.Heading>
          <Panel.Body>
        	{this.renderChart()}
          </Panel.Body>
        </Panel> 
	  </center>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/summary/TripsChart.js